// @flow
import * as React from 'react';
import { components } from 'react-select-5';
import { Box, Flex, Icon } from '@locus-taxy/neo-ui';

const { Control: BaseControl } = components;

const Control = ({ children, ...props }: $FixMe): React.Node => (
    <BaseControl {...props}>
        <Box width="100%">
            <Flex alignItems="center">
                <Box ml={2} mt={1}>
                    <Icon icon="search" color="grey.300" size="large" />
                </Box>
                {children}
            </Flex>
        </Box>
    </BaseControl>
);

export default Control;
